(() => {
  // app/scripts/product-description.js
  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
  customElements.define("product-description-component", class productDescription extends HTMLElement {
    constructor() {
      super();
      let curr_url = window.location.href;
      if (curr_url.includes("control")) {
        let target = curr_url.split("?control=")[1];
        this.querySelectorAll(".tab-content--heading").forEach((e) => {
          if (e.dataset.control == target) {
            this.toggleTab(e);
            const targetOffsetTop = this.getBoundingClientRect().top - 150;
            console.log("targetOffsetTop", targetOffsetTop);
            window.scrollTo({
              top: targetOffsetTop,
              behavior: "smooth"
            });
          }
        });
      }
      this.addEventListener("click", (e) => {
        const { target } = e;
        if (target.closest(".tab-content--heading")) {
          e.preventDefault();
          this.toggleTab(target);
        }
        if (target.closest(".jsScrollTo") && target.closest("sticky-component.active")) {
          e.preventDefault();
          this.scrollTo(target.closest(".jsScrollTo").dataset.scroll);
        }
        if (target.closest(".navigation-next")) {
          let next_element = this.querySelector(".tab-content--heading.active").nextElementSibling;
          if (next_element.getAttribute("aria-control") != null) {
            this.toggleTab(next_element);
          } else {
            return;
          }
        }
        if (target.closest(".navigation-back")) {
          let prev_element = this.querySelector(".tab-content--heading.active").previousElementSibling;
          if (prev_element.getAttribute("aria-control") != null) {
            this.toggleTab(prev_element);
          } else {
            return;
          }
        }
      });
    }
    toggleTab(element) {
      this.querySelectorAll(".tab-content--heading.active").forEach((button) => {
        const tabEl2 = this.querySelector(button.getAttribute("aria-control"));
        button.classList.remove("active");
        tabEl2.classList.remove("active");
        console.log("element", element);
        let url = window.location.href;
        if (element.dataset.control == "dimension")
          this.classList.add("dimension-hide");
        else
          this.classList.remove("dimension-hide");
        if (url.includes("control")) {
          url = url.split("?control=")[0];
        }
        url = url + `?control=${element.dataset.control}`;
        window.history.replaceState("", "", url);
      });
      const tabEl = this.querySelector(element.getAttribute("aria-control"));
      element.classList.add("active");
      tabEl.classList.add("active");
    }
    // scrollTo(selector){
    // 	const targetOffsetTop = document.querySelector(selector).getBoundingClientRect().top + document.documentElement.scrollTop;
    // 	const bottom = this.querySelector('sticky-component').getBoundingClientRect().top;
    // }
  });
})();
